import { render, staticRenderFns } from "./EditQuotation.vue?vue&type=template&id=22866f0f"
import script from "./EditQuotation.vue?vue&type=script&lang=js"
export * from "./EditQuotation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports